/** Facets + filter matching for Workforce assistant list. */

export const EMPTY_WORKFORCE_FILTERS = {
    status: [],
    opcodeCount: [],
    channels: [],
    knowledge: [],
};

export function getOpcodeBucket(count) {
    if (count === 0) return '0';
    if (count === 1) return '1';
    if (count <= 3) return '2-3';
    return '4+';
}

export function getAssistantFacets(assistant) {
    const opcodes = Array.isArray(assistant?.opcodes) ? assistant.opcodes.length : 0;
    const channelCount = assistant?.channels?.authorized_channels?.length || 0;
    const live = assistant?.status === 'active' && !assistant?.disabled;
    const knowledgeCount = Array.isArray(assistant?.knowledge) ? assistant.knowledge.length : 0;

    return {
        status: live ? 'live' : 'draft',
        opcodeCount: getOpcodeBucket(opcodes),
        opcodeCountRaw: opcodes,
        channels: channelCount > 0 ? 'has' : 'none',
        channelCount,
        knowledge: knowledgeCount > 0 ? 'has' : 'none',
    };
}

export function matchesWorkforceFilters(assistant, filters) {
    const f = getAssistantFacets(assistant);

    if (filters.status?.length && !filters.status.includes(f.status)) return false;
    if (filters.opcodeCount?.length && !filters.opcodeCount.includes(f.opcodeCount)) return false;
    if (filters.channels?.length && !filters.channels.includes(f.channels)) return false;
    if (filters.knowledge?.length && !filters.knowledge.includes(f.knowledge)) return false;

    return true;
}

export function filterAssistants(assistants, filters) {
    const active = filters && Object.values(filters).some((v) => Array.isArray(v) && v.length > 0);
    if (!active) return assistants;
    return assistants.filter((a) => matchesWorkforceFilters(a, filters));
}

export function buildWorkforceFacetCounts(assistants) {
    const counts = {
        status: { live: 0, draft: 0 },
        opcodeCount: { 0: 0, 1: 0, '2-3': 0, '4+': 0 },
        channels: { none: 0, has: 0 },
        knowledge: { none: 0, has: 0 },
    };

    assistants.forEach((a) => {
        const f = getAssistantFacets(a);
        counts.status[f.status] += 1;
        counts.opcodeCount[f.opcodeCount] += 1;
        counts.channels[f.channels] += 1;
        counts.knowledge[f.knowledge] += 1;
    });

    return counts;
}

export function hasActiveWorkforceFilters(filters) {
    return Object.values(filters || {}).some((v) => Array.isArray(v) && v.length > 0);
}
